// this would be the selection between single and double chair --> only in this cases we need a general rerender of the entire section
class ProductSwatch extends HTMLElement {
	constructor() {
		super();
		this.color = this.dataset.color;
		this.sectionId = this.dataset.sectionId;
		this.productHandle = this.dataset.productHandle;
		this.firstOptionId = this.dataset.firstOptionId;
		this.secondOptionId = this.dataset.secondOptionId;
	}
	connectedCallback() {
		// runs when html element is rendered
		if(document.readyState == 'loading') {
			document.addEventListener('DOMContentLoaded', () => {
				this.setListener();
			});
		} else {
			this.setListener();
		}
	}
	setListener() {
		this.addEventListener('click', () => {
			this.changeProduct()
		});
	}
	// this should be called if the component is clicked.
	// init this function in the connectedCallback with a clicklistener
	changeProduct() {
		this.rerenderSection();
	}

	rerenderSection() {
		// console.log("Rerendering section", sectionId, productHandle);
		let section = document.querySelector(`#shopify-section-${this.sectionId}`);
		// if section is empty, we are in the quickbuy container
		if (!!!section) {
			console.log("No section found");
			return;
		}
		const params = new URLSearchParams();

		const newUrl = new URL(document.location);
		newUrl.search = params.toString();
		newUrl.pathname = '/products/' + this.productHandle; // aktuelle url muss dann auch wieder angepasst werden		

		if (this.firstOptionId != 0 && this.secondOptionId === undefined) {
			params.set('option_values', this.firstOptionId);
		} else if (this.firstOptionId != 0 && this.secondOptionId != undefined) {
			const optionValues = [this.firstOptionId, this.secondOptionId];
			params.set('option_values', optionValues.join(','));
		}
		newUrl.search = params.toString();
		window.history.replaceState(null, 'product -> ' + this.productHandle, newUrl.href);
		params.set('section_id', this.sectionId);
		newUrl.search = params.toString();
		console.log("[CLIQ] Rerendering section", newUrl.href);
		fetch(newUrl.href, {
			credentials: 'same-origin',
			headers: {'X-Requested-With': 'XMLHttpRequest'},
			method: 'GET'
		})
		.then(response => response.text())
		.then(data => {
			let template = document.createElement('template');
			template.innerHTML = data.trim();
			let firstChild = template.content.firstChild;
			const sectionChild = section.querySelector('.modul-grid'); 
			const firstChildChild= firstChild.querySelector('.modul-grid');
			if (section && firstChild && sectionChild && firstChildChild) {
				sectionChild.replaceWith(firstChildChild);
			} else {
				console.log("No section or replacement found");
			}
		})
		.catch(function(err) {
			console.error(err);
		});
	}
}
customElements.define('product-swatch', ProductSwatch);

// colorpicker and color-swatches --> only need the color-swatches. Can wrap them inside a normal div-container
// A bundlevariant is a combination of 2 colors! INFO: Black/Moss has another Variant ID than Moss/Black
// do I need a mapping for the variant ID's?
// die 2. Reihe sind dann die ID's fuer die eigentliche Variante zur Farbe Black z.B. 
class ColorSwatch extends HTMLElement {
	constructor() {
		super();
		this.optionValueId = this.dataset.optionValueId;
		this.row = this.dataset.row;
		this.colorName = this.dataset.optionValue;
		this.productHandle = this.dataset.productHandle;
		this.parent = this.closest(`.chair-${this.row}`);
	}
	connectedCallback() {
		this.setListener();
	}
	setListener() {
		this.addEventListener('click', () => {
			this.variantChange()
		});
		this.addEventListener('mouseover', () => {
			this.changeColorValue()
		});
	}
	disconnectedCallback() {
		// remove it, so nothing can be changed or clicked while the section is loading
		this.removeEventListener('click', () => {
			this.variantChange()
		});
		this.removeEventListener('mouseover', () => {
			this.changeColorValue()
		});
	}
	changeColorValue() {
		// console.log("[CLIQ] changeColorValue");
		const colorSwatches = document.querySelector(`[data-row-${this.row}-selected]`);
		if (!!colorSwatches) {
			colorSwatches.innerHTML = this.colorName;
		}
	}
	variantChange() {
		// console.log("[CLIQ] setNewVariant;OptionValues");
		this.parent.classList.add('loading');
		

		// Assumes the option value picker is wrapped in a section with a class optionValueSelectors with a section-id data attribute
		const optionValueSelectors = this.closest('.option-value-selectors');
		const sectionId = optionValueSelectors.dataset.sectionId;

		const section = document.querySelector(`#shopify-section-${sectionId}`);
		const oldGalleryDesktop = section.querySelector('[gallery-wrapper-desktop]');
		if (oldGalleryDesktop) {
			oldGalleryDesktop.classList.add("gallery-loading");
		}
		const oldGallery = section.querySelector('[slider-wrapper]');
		if (oldGallery) {
			oldGallery.classList.add("gallery-loading");
		}
		const querySelectorAll = optionValueSelectors.querySelectorAll(`[data-row="${this.row}"]`);
		querySelectorAll.forEach((element) => {
			element.removeAttribute('checked');
		});
		this.setAttribute('checked', '');
		// Get the selected option value IDs and format as query param
		const selectedOptionValues = Array.from(
			optionValueSelectors.querySelectorAll(`[checked]`)
		).map(({dataset}) => dataset.optionValueId);

		const params = selectedOptionValues.length > 0 ? `${selectedOptionValues.join(',')}` : '';

		const newUrl = new URL(document.location);
		const newParams = new URLSearchParams();
		newParams.set('option_values', params);
		newUrl.search = newParams.toString();
		window.history.replaceState(null, 'product -> ' + this.productHandle, newUrl.href);
		newParams.set('section_id', sectionId);
		newUrl.search = newParams.toString();
		// Fetch the product section with the new option value selection, and replace the option value picker with the new availability state
		fetch(newUrl.href)
		.then((response) => response.text())
		.then((responseText) => {
			const html = new DOMParser().parseFromString(responseText, 'text/html');

			
			const newGallery = html.querySelector('[slider-wrapper]');

			const newGalleryDesktop = html.querySelector('[gallery-wrapper-desktop]');

			const oldProductSelection = section.querySelector('.product-selection');
			const newProductSelection = html.querySelector('.product-selection');
			
			const oldATC = section.querySelector('set-atc.submit-button');
			const newATC = html.querySelector('set-atc.submit-button');

			if (oldProductSelection && newProductSelection) {
				oldProductSelection.replaceWith(newProductSelection);
			} else {
				console.log("No product selection or replacement found");
			}

			if (oldGallery && newGallery) {
				oldGallery.replaceWith(newGallery);
			} else {
				console.log("No slider or replacement found");
			}
			if (oldGalleryDesktop && newGalleryDesktop) {
				oldGalleryDesktop.replaceWith(newGalleryDesktop);
			} else {
				console.log("No gallery or replacement found");
			}
			if (oldATC && newATC) {
				oldATC.replaceWith(newATC);
			} else {
				console.log("No ATC or replacement found");
			}
			const newOptionValueSelectors = html.querySelector('.option-value-selectors');
			if (newOptionValueSelectors) {
				optionValueSelectors.innerHTML = newOptionValueSelectors.innerHTML;
			}
			this.parent.classList.remove('loading');
		});
  }
}
customElements.define('color-swatch', ColorSwatch);

class SetAtc extends HTMLElement {
	constructor() {
		super();
		this.form = document.querySelector('form.product-form');
		this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
	}
	connectedCallback() {
		this.setListener();
	}
	setListener() {
		this.addEventListener('click', (event) => {
			this.triggerATCEvent(event)
		});
	}
	triggerATCEvent(event) {
		const formData = new FormData(this.form);
		const loadingSpinner = this.querySelector('.loading-overlay__spinner');
		const displayText = this.querySelector('[data-display]');
		loadingSpinner?.classList.remove('hidden');
		displayText?.classList.add('hidden');
		if (this.cart) {
			formData.append(
				'sections',
				this.cart.getSectionsToRender().map((section) => section.id)
			);
			formData.append('sections_url', window.location.pathname);
			this.cart.setActiveElement(document.activeElement);
		}
		// for (var [key, value] of formData.entries()) { 
		// 	console.log(key, value);
		// }
		fetch(window.Shopify.routes.root + 'cart/add.js',   
			{
				method: 'POST',
				headers: {
					credentials: 'same-origin',
				},
				body: formData
			})
			.then((response) => response.json())
			.then((response) => {
				if (response.status) {
					publish(PUB_SUB_EVENTS.cartError, {
						source: 'product-form',
						productVariantId: formData.get('id'),
						errors: response.errors || response.description,
						message: response.message,
					});
					return;
				} else if (!this.cart) {
					window.location = window.routes.cart_url;
					return;
				}
				
				// console.log("productVariantId: ", formData.get('id'));
				if (!this.error) {
					publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
				}
				this.error = false;
				this.cart.renderContents(response);
			})
			.catch((e) => {
				console.error(e);
			})
			.finally(() => {
				if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
				loadingSpinner?.classList.add('hidden');
				displayText?.classList.remove('hidden');
				document.dispatchEvent(new CustomEvent('cart:updated'));
			});
  }
}
customElements.define('set-atc', SetAtc);